import { render, staticRenderFns } from "./plan-management.vue?vue&type=template&id=00b670fa&scoped=true"
import script from "./plan-management.vue?vue&type=script&lang=ts"
export * from "./plan-management.vue?vue&type=script&lang=ts"
import style0 from "./plan-management.vue?vue&type=style&index=0&id=00b670fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b670fa",
  null
  
)

export default component.exports